import { layout } from "Constants";
import styled from "styled-components";

const { default: Container } = require("./Container");

const PaddedContainer = styled(Container)`
  padding: 0px 118px 110px 118px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    padding: 10px;
  }
`;

export default PaddedContainer;

